import useMasterKeyWorkflow from "./useMasterKeyWorkflow";

export default function useEvaluationMasterKeyWorkflow(options) {
  return useMasterKeyWorkflow({ ...options, resetOutcome: "generic" });
}
